// extracted by mini-css-extract-plugin
module.exports = {"glowingBackdrop":"GlowingBackdrop_glowingBackdrop__igxwa"};